export default (component: string, style: {[key: string]: string}, classNames: {[key: string]: boolean} = {}): string => {
    return [component, ...Object.keys(classNames).filter(key => classNames[key])].map(key => style[key]).join(' ');
}